<template>  
    <div name="search" class="search" ref="search" draggable="true">
      <div class="modal-header" style="flex-direction: column;">
        <div class="head-container">
          <h3 class="modal-title">Search</h3>
          <a v-on:click="CloseDialog()" title="Close" class="close">×</a>
        </div>
        <div class="wrapper">
          <div class="search-wrapper">
            <input type="text" v-model="search" placeholder="Search title.." @input="showMenu()"/>
            <!-- <label>Search title:</label> -->
          </div>
          <div class="wrapperBtn">
            <button>
              <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 7L10 12L15 17" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <button>
              <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 7L15 12L10 17" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div class="modal-body search-body">
        <ul class="result">
          <li v-for="(item, index) in this.filteredList" :key="index" @click="showResult(item)">
            <div v-if="item.name">{{item.name}}</div>
            <div v-if="item.value.tablename">{{item.value.tablename}}</div>
          </li>
        </ul>
        <div class="buttons">
          <button class="btn btn-secondary" v-on:click="CloseDialog()">Ok</button>
        </div>
      </div>
    </div>
  <!-- </div> -->
</template>

<script>
import { commonMixin } from '../../common.js'
export default {
  mixins: [commonMixin],
  props: {
    menuList: {
      type: Array,
      required: true
    },
    dbList: {
      type: Array,
      required: true
    }
  },
  data() {
    return { 
      search: '',
      showSearch: false,
      tableN: [],
      filterSearch: null,
      result: 10
    }
  },
  computed: {
    filteredList() {
      let res = []
      let arr = []
      if(this.search) {
        this.dbList.forEach((i,inxDb)=>{
          if (i.dbname.toLowerCase().includes(this.search.toLowerCase())) {
            res.push({"name": i.dbname,"value": i.dbname + " " + i.port, 'indDb': inxDb})
          }
          // console.log('filteredList data', i.data);
          if (i.data && i.data.length > 0) {
            arr = i.data.forEach((elem,inxTbl) => {
              if (elem.tablename.toLowerCase().includes(this.search.toLowerCase())) {
                let el = {'value':elem, 'inxTbl':inxTbl, 'indDb': inxDb}
                // console.log('el',el)
                res.push(el)
              }
            })
            // res = res.concat(arr)            
          }
        })
      }
      this.result = res
      // console.log('filteredList res', res);
      return res      
    },    
    height() {
      // console.log(this.result.Length);
      return this.result.Length * 15
    }
  },
  methods: {
    showMenu() {   
      this.filterSearch = this.filteredList
    },
    CloseDialog(){
      this.filterSearch = null
      this.$emit('closeSerch', false)
    },
    showResult(item) {      
      if(this.menuList[item.indDb] && this.menuList[item.indDb].expanded === false) {
        this.menuList[item.indDb].expanded = true
        this.menuList[item.indDb].y = this.menuList[item.indDb].expandedY        
      } 
      if (this.menuList[item.indDb].childs && this.menuList[item.indDb].childs[0].expanded === false) {
        this.menuList[item.indDb].childs[0].expanded = true
        this.menuList[item.indDb].childs[0].y = this.menuList[item.indDb].childs[0].expandedY
        this.menuList[item.indDb].y = this.menuList[item.indDb].childs[0].expandedY + 1
      }
      let name 
      let obj = this
      while (obj) {
      if (obj.$refs['leftMenu']) {
        name = obj.$refs['leftMenu']
      }
      obj = obj.$parent
      }
      let clkEl      		
      if (item.hasOwnProperty('inxTbl')) {        
        if(name.elemClicked) {          
          name.elemClicked.choseEl = false
        }
        this.menuList[item.indDb].childs[0][item.value.tablename].choseEl = true
        name.elemClicked = this.menuList[item.indDb].childs[0][item.value.tablename]
        clkEl = this.menuList[item.indDb].childs[0][item.value.tablename]
      } else {        
        if(name.elemClicked) {          
          name.elemClicked.choseEl = false
        }
        this.menuList[item.indDb].choseEl = true
        name.elemClicked = this.menuList[item.indDb]
        clkEl = this.menuList[item.indDb]
      }
      if (name) {
        name.getArr()
      }   
      let y = 0
      console.log('showResult', item , clkEl);
      if(item.inxTbl) {
        if (item.indDb > 0) {
          this.menuList.forEach((i,ix)=> {
            if (ix < item.indDb) {
              console.log('yDb',i);
              y += i.y
            } 
          })
        } 
        y += item.inxTbl
        if (name) {
          name.getArr()
        }  
      } else {
        console.log('yDb else',);
        if (item.indDb > 0) {
          console.log('yDb else2',);
          this.menuList.forEach((i,ix)=> {
            if (ix < item.indDb) {
              console.log('yDb else3',i);
              y += i.y
            }
          })          
            if (name) {
              name.getArr()
            }  
        } else {
          console.log('yDb else3');
          y = 0
        }
      }
      // this.menuList.forEach((i,ix)=> {
      //   if (ix <= item.indDb) {
      //    console.log('yDb');
      //     y += i.y
      //   }
      // })
      // console.log('showResult',name.elNum);         
      // console.log('showResult2 db y',y);    
      // clkEl.parent.childs.forEach((i,ix)=> {
      //   if (ix <= clkEl.ind) {
      //     y += i.y
      //   }
      // })     
      console.log('showResult2', y); 
      let inter = setInterval(() => {
        if (name.$refs.scrollbar.max > 0) {          
          clearInterval(inter)
          name.$refs.scrollbar.setPosition((y)*20)
        }
      },10)
      // name.$refs.scrollbar.setPosition((y+2)*20)        
    }
  }
}
</script>

<style lang="scss">
  .wrapper {
    display: flex;
    width: 100%;
    gap: 10px;
  }
  .wrapperBtn {
    display: flex;  
  }
  .search {
    position: absolute;
    top: 30%;
    left: 30%;
    z-index: 1000;
    width: 500px;
    height: 300px;
    border: 1px solid #dee2e6;
    background-color: white;
  }
  .wrapper-comp {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 10px;
    button {
      outline: none;
      border: none;
      transition: .5s;
      &:hover {
        transition: .5s;
        transform: scale(1.1);
      }
    }
  }
  .search-wrapper {
    position: relative;
    label {
      position: absolute;
      font-size: 12px;
      color: rgba(0,0,0,.50);
      top: 8px;
      left: 12px;
      z-index: -1;
      transition: .15s all ease-in-out;
    }
    input {
      padding: 4px 12px;
      color: rgba(0,0,0,.70);
      border: 1px solid rgba(0,0,0,.12);
      transition: .15s all ease-in-out;
      background: white;
      &:focus {
        outline: none;
        transform: scale(1.05);
        & + label  {
          font-size: 10px;
          transform: translateY(-24px) translateX(-12px);
        }
      }
      &::-webkit-input-placeholder {
          font-size: 12px;
          color: rgba(0,0,0,.50);
          font-weight: 100;
      }
    }
  }
  .modal-header {
    display: flex;
    .head-container {
      display: flex;
      justify-content: space-between;
      width: 100%;
      padding-bottom: 15px;
    }
    .search-wrapper {
      width: 95%;
      input {
        width: 100%;
      }
    }
  }
  .modal-body {
    display: flex;
    flex-direction: column;
    height: 66%;
    justify-content: space-between;
  }
  .search-info {
    margin-left: 5px;
    opacity: .6;
    font-size: 12px;
  }
  .result {
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: auto;
    li {
      font-size: 14px;
    }
  }
</style>
